import React, { Component } from 'react';
import Modal from 'react-modal';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
class Stepper extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: false,
        };
    }

    handleOpenModal = (e) => {
        this.props.send(e);
        this.setState({ showModal: true });
    };

    handleCloseModal = () => {
        this.setState({ showModal: false });
        this.props.sendEnable(false);
    };

    render() {
        const { t } = this.props;
        return (
            <div className='stepper'>
                <div
                    onClick={this.props.prev}
                    className={`step prev-step ${
                        this.props.step === 1 ? 'disabled' : ''
                    }`}
                >
                    {t('prev')}
                </div>
                <div className='page-progress'>
                    <div className='page-title'>
                        {this.props.title[this.props.step - 1]}
                    </div>
                    <div className='page-num'>
                        0{this.props.step}/0{this.props.pageEnd}
                    </div>
                    <div className='progress-bar'>
                        <div
                            className='done'
                            style={{
                                width: `${
                                    this.props.done[this.props.step - 1]
                                }%`,
                            }}
                        ></div>
                        <div
                            className='left'
                            style={{
                                width: `${
                                    this.props.left[this.props.step - 1]
                                }%`,
                            }}
                        ></div>
                    </div>
                </div>
                {this.props.step === this.props.pageEnd ? (
                    <div className='last-step'>
                        <button
                            className={`last-step last-step-btn ${
                                this.props.clicked === true
                                    ? 'send-disable'
                                    : 'send-enable'
                            }`}
                            onClick={this.handleOpenModal}
                            disabled={this.props.canSend}
                        >
                            {this.props.clicked === true ? (
                                <>
                                    <span class='spinner pulse'>
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                    </span>
                                </>
                            ) : (
                                <>{t('send')}</>
                            )}
                        </button>
                        {this.props.canSend === false ? (
                            <></>
                        ) : (
                            <Modal
                                isOpen={this.state.showModal}
                                contentLabel='Send'
                                className='Modal'
                                overlayClassName='modal-overlay'
                            >
                                {t('modal.success')}
                                <Link to='/'>{t('modal.back')}</Link>
                            </Modal>
                        )}
                        {this.props.error === false ? (
                            <></>
                        ) : (
                            <Modal
                                isOpen={this.state.showModal}
                                contentLabel='Send'
                                className='Modal'
                                overlayClassName='modal-overlay'
                                onRequestClose={this.handleCloseModal}
                            >
                                {t('modal.error')}
                                <a
                                    style={{ cursor: 'pointer' }}
                                    onClick={this.handleCloseModal}
                                >
                                    {t('modal.back')}
                                </a>
                            </Modal>
                        )}
                    </div>
                ) : (
                    <div onClick={this.props.next} className='step next-step'>
                        {t('next')}
                    </div>
                )}
            </div>
        );
    }
}

export default withTranslation()(Stepper);
